export default {
  list: []
}



// WEBPACK FOOTER //
// ./src/features/banks/store/state.js